import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FeedbackProcesso } from '../models/feedback-processo.model';
import { FeedbackProcessoRequest } from '../models/feedback-processo-request.model';
import { FeedbackReferencia } from '../models/feedback-referencia.model';
import { ResponsavelReferencia } from '../models/responsavel-referencia.model';
import { EnviarFeedbackAawebRequest } from '../models/enviar-feedback-aaweb-request.model';
import { FeedbackProcessoRepository } from '../repositories/feedback-processo.repository';
import { DEFAULT_PAGINATION_PARAMS, PaginatedResponse } from '../../../core/shared/models/pagination.model';
import { FeedbackListParams } from '../models/feedback-list-params.model';

@Injectable({
  providedIn: 'root'
})
export class FeedbackProcessoService implements FeedbackProcessoRepository {
  private readonly apiFeedbackProcesso = 'evento/';

  constructor(private readonly http: HttpClient) { }

  listarFeedbacksProcesso(params: FeedbackListParams = { ...DEFAULT_PAGINATION_PARAMS }): Observable<PaginatedResponse<FeedbackProcesso>> {
    let queryParams = new HttpParams()
      .set('page', params.page)
      .set('size', params.size);
    if (params.nome?.trim()) queryParams = queryParams.set('nome', params.nome.trim());
    if (params.tipoFeedback) queryParams = queryParams.set('tipoFeedback', params.tipoFeedback);
    if (params.responsavel) queryParams = queryParams.set('responsavel', params.responsavel);
    if (params.status) queryParams = queryParams.set('status', params.status);

    return this.http.get<PaginatedResponse<FeedbackProcesso>>(
      `${environment.FI_FINANC_IMOB_BE}${this.apiFeedbackProcesso}listarTodos`,
      { params: queryParams }
    );
  }

  buscarFeedbackProcessoPorId(idFeedback: number): Observable<FeedbackProcesso> {
    return this.http.get<FeedbackProcesso>(`${environment.FI_FINANC_IMOB_BE}${this.apiFeedbackProcesso}buscar/${idFeedback}`);
  }

  criarFeedbackProcesso(payload: FeedbackProcessoRequest): Observable<FeedbackProcesso> {
    return this.http.post<FeedbackProcesso>(`${environment.FI_FINANC_IMOB_BE}${this.apiFeedbackProcesso}criar`, payload);
  }

  editarFeedbackProcesso(idFeedback: number, payload: FeedbackProcessoRequest): Observable<FeedbackProcesso> {
    return this.http.put<FeedbackProcesso>(`${environment.FI_FINANC_IMOB_BE}${this.apiFeedbackProcesso}atualizar/${idFeedback}`, payload);
  }

  excluirFeedbackProcesso(idFeedback: number): Observable<void> {
    return this.http.delete<void>(`${environment.FI_FINANC_IMOB_BE}${this.apiFeedbackProcesso}deletar/${idFeedback}`);
  }

  listarReferencisFeedback(): Observable<FeedbackReferencia[]> {
    return this.http.get<FeedbackReferencia[]>(`${environment.FI_FINANC_IMOB_BE}${this.apiFeedbackProcesso}referencia/feedback`);
  }

  listarReferenciasResponsavel(): Observable<ResponsavelReferencia[]> {
    return this.http.get<ResponsavelReferencia[]>(`${environment.FI_FINANC_IMOB_BE}${this.apiFeedbackProcesso}referencia/responsavel`);
  }


  enviarFeedbackAaweb(propostaId: string, eventoId: number, numSeqEtapa: number, payload: EnviarFeedbackAawebRequest): Observable<void> {
    return this.http.post<void>(
      `${environment.FI_FINANC_IMOB_BE}${this.apiFeedbackProcesso}processo/${propostaId}/evento/${eventoId}/etapa/${numSeqEtapa}/inserirTempo`,
      payload
    );
  }
}
